export default () => ({
    darkMode: 'light',
    init() {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        this.darkMode = prefersDark ? 'dark' : 'light';
        this.$el.value = this.darkMode;

        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
            this.darkMode = e.matches ? 'dark' : 'light';
            this.$el.value = this.darkMode;
        });
    }
})
